document.addEventListener('turbolinks:load', function () {
  // ¥ 開発環境での開発スピードを上げるため青木の開発環境でのみ
  // ¥ manage/app/javascript/packs内の本jsファイルを走らせない
  if ((location.href.includes('dev-manage-ssl.platta.jp') || location.href.includes('http://18.177.103.115:3004')) && !location.href.includes('?dev27aoki')) {
    console.log('dev環境 public.jsを使用');
    return;
  }

  const ERROR_MSG = 'エラー！ 処理を完了できませんでした\n時間おいて再度実行しても、このエラーが修正されない場合は\nお手数ですがサポートチームにお問い合わせください';
  const MAIL_PATTERN = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  const PASSWORD_PATTERN = /([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/;

  const DOMAIN = $('#pl_domain').val();

  let current_url = location.href;

  //############################################################
  // 入力情報欄のtoggle
  //############################################################
  $('.push_slideup_btn, .parent_slideup_btn').on('click', function () {
    $.when($(this).parent().parent().children('.push_slide_flag, .parent_slide_flag').slideUp()).done($(this).fadeOut(0), $(this).parent().children('.push_slidedown_btn, .parent_slidedown_btn').fadeIn(0));
  });

  $('.push_slidedown_btn, .parent_slidedown_btn').on('click', function () {
    $.when($(this).parent().parent().children('.push_slide_flag, .parent_slide_flag').slideDown()).done($(this).fadeOut(0), $(this).parent().children('.push_slideup_btn, .parent_slideup_btn').fadeIn(0));
  });

  // プッシュ通知分析
  function push_notification_update_url() {
    const push_topic_id = $('#push_topic_select_box option:selected').val();
    const gf = $('#push_topic_graph_pattern_select_input').val();
    // const ab = $('#block_exit_ab_test_select_box option:selected').val();
    const device = $('.push_notification_device_select').data('device');
    const start_day = $('#push_topic_report_start_day').val();
    const end_day = $('#push_topic_report_end_day').val();

    let url = new URL(window.location.href);
    let params = url.searchParams;

    if (push_topic_id !== 'none' && push_topic_id !== null && push_topic_id !== undefined) {
      params.set('push_topic_id', push_topic_id);
    } else {
      params.delete('push_topic_id');
    }

    if (gf) {
      params.set('gf', gf);
    } else {
      params.delete('gf');
    }

    if (device == '0' || device == '1') {
      params.set('device', device);
    } else {
      params.delete('device');
    }

    if (gf === '12') {
      params.delete('start_day');
      params.delete('end_day');
    } else {
      // このelseブロックを追加
      if (start_day) {
        params.set('start_day', start_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }

      if (end_day) {
        params.set('end_day', end_day);
      } else {
        params.delete('start_day');
        params.delete('end_day');
      }
    }

    url.search = params.toString();
    location.href = url.toString();
  }

  // #################################################################
  // プッシュ通知の選択
  // #################################################################
  $('#push_topic_select_box').on('change', function () {
    push_notification_update_url();
  });

  // #################################################################
  // 日毎、月毎のグラフ切り替え
  // #################################################################
  $('.push_topic_graph_pattern_select_day, .push_topic_graph_pattern_select_month').on('click', function () {
    const gf_value = $(this).data('gf');
    $('#push_topic_graph_pattern_select_input').val(gf_value);
    push_notification_update_url();
  });

  // #################################################################
  // デバイスごとのグラフ切り替え
  // #################################################################
  $('.push_notification_device_select_all, .push_notification_device_select_pc, .push_notification_device_select_phone').on('click', function () {
    const device = $(this).data('device');
    $('.push_notification_device_select').data('device', device);
    push_notification_update_url();
  });

  // #################################################################
  // 範囲選択によるグラフ切り替え
  // #################################################################
  $('#push_topic_report_start_day, #push_topic_report_end_day').on('change', function () {
    push_notification_update_url();
  });

  // #################################################################
  // 表の年月切り替え
  // #################################################################
  $('#ua_push_topic_month_selects').on('change', function () {
    let push_topic_id = $('#push_topic_select_box option:selected').val();
    let month = $('#ua_push_topic_month_selects option:selected').val();
    let url = new URL(window.location.href);

    if (month != '') {
      if (url.searchParams.has('m')) {
        // 値が "0"か"1" なら "2" に更新する
        let new_value = month;
        // パラメーターの値を更新する
        url.searchParams.set('m', new_value);
      } else {
        // パラメーターにdeviceがない場合
        // 新しいパラメーターを追加する
        url.searchParams.append('m', month);
      }

      // 更新されたURLにリダイレクトする
      location.href = url.toString();
    } else {
      // monthが空文字の時は指定したURLにリダイレクトする
      // location.href = 'ugc_analysis';
    }
  });

  // #################################################################
  // プッシュ通知のログデータのみの削除
  // #################################################################
  $('.delete_push_notification_log_data').on('click', function () {
    if (!confirm('本当に削除を実行しますか？')) {
      return;
    }
    const push_topic_id = $('#push_topic_select_box option:selected').val();

    $.ajax({
      url: '/push_notification_report/delete_push_notification_log',
      type: 'POST',
      data: {
        push_topic_id: push_topic_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // 離脱防止のログデータと関連するデータ全ての削除
  // #################################################################
  $('.delete_push_notification_log_data_and_related_data').on('click', function () {
    if (!confirm('本当に完全削除を実行しますか？')) {
      return;
    }
    const push_topic_id = $('#push_topic_select_box option:selected').val();

    $.ajax({
      url: '/push_notification_report/delete_push_notification_log_data_and_related_data',
      type: 'POST',
      data: {
        push_topic_id: push_topic_id,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        alert('削除が完了しました。');
        location.href = '/push_notification_report/index';
      }
    });
  });

  // #################################################################
  // プッシュ通知のレポートのcsv出力
  // #################################################################
  $('#download_push_notification_csv').on('click', function () {
    const push_topic_id = $('#push_topic_select_box option:selected').val();
    const month = $('#ua_push_topic_month_selects option:selected').val();
    const device = $('.push_notification_device_select').data('device');

    let href = '/push_notification_report/download_push_notification_csv';

    href += `?push_topic_id=${push_topic_id}`;
    href += `&m=${month}`;
    href += `&device=${device}`;

    location.href = href;
  });

  // ###############################################################
  // 現在時刻を取得 - フォーマット: 20231107_11_02_04_40_07
  // プッシュ通知で複数に同時送信可能にするためのtopic名を一意にするためのtopic名の一部にするために使用する
  // ###############################################################
  function getCurrentFormattedTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    // Concatenate the date and time in the desired format
    return `${year}${month}${day}_${hours}_${minutes}_${seconds}`;
  }

  // #################################################################
  // プッシュ通知の切り替え
  // #################################################################
  $('.push_selects').on('change', function () {
    let push_topic_id = $('.push_selects option:selected').val();
    if (push_topic_id == 'new') {
      $('.push_set_wrapper_display').css('display', 'block');
      $('.push_name_setting_wrapper').css('display', 'none');
      $('.push_device_setting_wrapper').css('display', 'none');
      $('.push_show_valid_setting_wrapper').css('display', 'none');
      $('.push_url_setting_wrapper').css('display', 'none');
      $('.push_preview_setting_wrapper').css('display', 'none');
      $('.push_preview_url_list_wrapper').css('display', 'none');
      $('.push_preview_position_setting_wrapper').css('display', 'none');
      $('.push_modal_setting_wrapper').css('display', 'none');
      $('.push_jump_url_setting_wrapper').css('display', 'none');
      $('.push_img_url_setting_wrapper').css('display', 'none');
      $('.push_modal_img_url_setting_wrapper').css('display', 'none');
      $('.push_icon_upload_wrapper').css('display', 'none');
      $('.push_modal_icon_upload_wrapper').css('display', 'none');
      $('.push_notification_title_setting_wrapper').css('display', 'none');
      $('.push_notification_message_setting_wrapper').css('display', 'none');
      $('.push_notification_send_wrapper_display').css('display', 'none');
      $('.edit-only').css('display', 'none');
    } else {
      location.href = `/push_notification/index?push_topic_id=${push_topic_id}`;
    }
  });

  // #################################################################
  // プッシュ通知のデバイスの切り替え
  // #################################################################
  $('.push_device_selects').on('change', function () {
    let push_topic_id = $('.push_device_selects:checked').data('push_topic_id');
    let is_device = $('.push_device_selects:checked').data('device');
    location.href = `/push_notification/index?push_topic_id=${push_topic_id}&is_device=${is_device}`;
  });

  // #################################################################
  // プッシュ通知管理の新規作成
  // #################################################################
  $('#push_create').on('click', function () {
    const push_name = $('.push_input').val();
    const ac_id = $('#push_ac_id').val();

    let current_time = getCurrentFormattedTime();

    let complete_topic = `${ac_id}_${current_time}`;

    if (!push_name) {
      alert('プッシュ通知名を入力して下さい。');
      return;
    }

    $.ajax({
      url: '/push_notification/create_push_notification',
      type: 'POST',
      data: {
        push_name: push_name,
        topic: complete_topic,
      },
      dataType: 'json',
    })
      .done(function (data) {
        if (data.ret == '0') {
          alert('新規登録されました。');
          location.href = `/push_notification/index?push_topic_id=${data.push_topic_id}&device=${data.is_device}`;
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.log('jqXHR: ', jqXHR);
        alert('予期せぬ理由で登録に失敗しました。再度お試しください。');
        location.reload();
      });
  });

  // #################################################################
  // プッシュ通知名の編集
  // #################################################################
  $('#push_name_edit_btn').on('click', function () {
    let push_topic_id = $('.push_selects option:selected').val();
    let push_name = $('.push_name_val').val();

    if (!push_name) {
      alert('名称を記入して下さい。');
      return;
    }

    $.ajax({
      url: '/push_notification/save_push_name',
      type: 'POST',
      data: {
        push_topic_id: push_topic_id,
        push_name: push_name,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }
    });
  });

  // #################################################################
  // プッシュ通知の表示URL設定
  // #################################################################
  $('#push_url_add_input').on('click', function () {
    $(this)
      .parents('table')
      .append(
        `<tr>
            <th></th>
            <td class="h-50px py-0 text-left ">
              <input class="push_url_input w-390px h-30px py-0 px-3 border-b dark:border-none" type="text">
            </td>
            <td class="h-50px py-0 px-6 text-left ">
              <div class="push_url_del text-2xl cursor-pointer text-gray-400 dark:text-gray-600">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15" />
                </svg>
              </div>
            </td>
          </tr>`
      );
    $('.push_url_del').on('click', function () {
      $(this).parent().parent('tr').remove();
    });
  });
  $('.push_url_del').on('click', function () {
    $(this).parent().parent('tr').remove();
  });

  $('#push_url_set').on('click', function () {
    let push_topic_id = $('.push_selects option:selected').val();
    let urls = [];
    $('.push_url_input').each(function () {
      urls.push($(this).val().trim());
    });

    $.ajax({
      url: '/push_notification/set_push_url',
      type: 'POST',
      data: {
        push_topic_id: push_topic_id,
        urls: urls,
      },
      dataType: 'json',
    }).done(function (data) {
      location.reload();
    });
  });

  // #################################################################
  // プッシュ通知のプレビュー作成
  // #################################################################
  $('#push_create_preview_btn')
    .off()
    .on('click', function () {
      $('.loadding').css('display', 'block');
      let push_topic_id = $('.push_selects option:selected').val();
      let is_device = $('.push_device_selects:checked').data('device');
      let topic_name = $('#push_topic_name').val();
      let preview_url = $('#push_create_preview_url').val();
      let preview_html_name = $('#push_create_preview_html_name').val();
      if (push_topic_id == '' || push_topic_id == null || preview_url == '' || preview_html_name == '') {
        $('.loadding').css('display', 'none');
        alert('必須項目を入力してください。');
        return;
      }

      $.ajax({
        url: '/push_notification/save_push_preview',
        type: 'POST',
        data: {
          push_topic_id: push_topic_id,
          is_device: is_device,
          topic_name: topic_name,
          url: preview_url,
          file_name: preview_html_name,
        },
        dataType: 'json',
      }).done(function (data) {
        if (data.ret == '0') {
          location.reload();
        }
      });
    });

  // #################################################################
  // プッシュ通知のプレビュー編集
  // #################################################################
  $('.create_push_preview_html_edit').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/push_notification/edit_push_preview_html',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        // モーダルを作成し、HTMLコンテンツとボタンを表示
        let modalHtml = `<div id="html_modal_wrapper"></div>
                        <div id="html_modal_container" class="fixed p-5 top-[2.5%] left-1/2 transform -translate-x-1/2 w-90per h-90per overflow-auto text-center bg-white dark:text-gray-500 dark:bg-gray-900 dark:border-b dark:border-black">
                          <div class="border border-gray-200 h-90per mb-4">
                            <textarea id="html_modal_text_area" class="p-2 h-full w-full"></textarea>
                          </div>
                          <div class="flex justify-center">
                            <div id="html_remove_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-gray-500 hover:bg-gray-700 dark:hover:bg-gray-600 dark:bg-gray-800 dark:text-gray-500">閉じる</div>
                            <div id="html_save_btn" class="btn text-14px w-250px p-3 cursor-pointer text-center text-white rounded-md bg-base-800 hover:bg-base-800 ml-2 dark:bg-dark_base dark:hover:bg-dark_base-hover dark:text-gray-500">保存</div>
                          </div>
                        </div>`;

        // モーダルをbody要素に追加
        $('body').append(modalHtml);
        $('#html_modal_text_area').text(data.html_content);

        $('#html_save_btn').on('click', function () {
          let html = $('#html_modal_text_area').val();
          $.ajax({
            url: '/push_notification/update_push_preview_html',
            type: 'POST',
            data: {
              id: preview_id,
              url: preview_url,
              html: html,
            },
            dataType: 'json',
          }).done(function (data) {
            if (data.ret == '0') {
              location.reload();
            }
          });
        });

        $('#html_modal_wrapper, #html_remove_btn').on('click', function (e) {
          $('#html_modal_wrapper, #html_modal_container, #html_modal_text_area, #html_save_btn').remove();
        });
      }
    });
  });

  // #################################################################
  // プッシュ通知のプレビュー削除
  // #################################################################
  $('.create_push_preview_url_delete').on('click', function () {
    let preview_id = $(this).data('id');
    let preview_url = $(this).data('url');
    $.ajax({
      url: '/push_notification/delete_push_preview',
      type: 'POST',
      data: {
        id: preview_id,
        url: preview_url,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  //############################################################
  // 通知許可モーダルのデザイン更新 js利用
  //############################################################
  $('#push_modal_custom_set').on('click', function () {
    let is_device = $('#is_device').val();
    let modal_transition_second = $('#modal_transition_second').val();
    let modal_whole_margin = $('#modal_whole_margin').val();
    let modal_whole_padding = $('#modal_whole_padding').val();
    let modal_whole_width = $('#modal_whole_width').val();
    let modal_whole_height = $('#modal_whole_height').val();
    let modal_whole_border = $('#modal_whole_border').val();
    let modal_whole_radius = $('#modal_whole_radius').val();
    let paragraph_text = $('#paragraph_text').val();
    let paragraph_text_color = $('#paragraph_text_color').val();
    let modal_whole_background_color = $('#modal_whole_background_color').val();

    let modal_container_margin = $('#modal_container_margin').val();
    let modal_container_padding = $('#modal_container_padding').val();

    let is_reverse_icon_position = $('#is_reverse_icon_position').val();

    let modal_icon_object_fit = $('#modal_icon_object_fit').val();
    let modal_icon_width = $('#modal_icon_width').val();
    let modal_icon_height = $('#modal_icon_height').val();
    let modal_icon_margin = $('#modal_icon_margin').val();
    let modal_icon_padding = $('#modal_icon_padding').val();

    let paragraph_text_size = $('#paragraph_text_size').val();
    let paragraph_font_family = $('#paragraph_font_family').val();
    let paragraph_font_weight = $('#paragraph_font_weight').val();
    let paragraph_margin = $('#paragraph_margin').val();
    let paragraph_padding = $('#paragraph_padding').val();
    let paragraph_line_height = $('#paragraph_line_height').val();
    let is_reverse_buttons_position = $('#is_reverse_buttons_position').val();
    let buttons_justify_content = $('#buttons_justify_content').val();
    let is_permission_button = $('#is_permission_button').val();
    let permission_button_text = $('#permission_button_text').val();
    let permission_button_margin = $('#permission_button_margin').val();
    let permission_button_padding = $('#permission_button_padding').val();
    let permission_button_background_color = $('#permission_button_background_color').val();
    let permission_button_text_size = $('#permission_button_text_size').val();
    let permission_button_text_color = $('#permission_button_text_color').val();
    let permission_button_font_family = $('#permission_button_font_family').val();
    let permission_button_font_weight = $('#permission_button_font_weight').val();
    let permission_button_text_style = $('#permission_button_text_style').val();
    let permission_button_border = $('#permission_button_border').val();
    let permission_button_border_radius = $('#permission_button_border_radius').val();
    let is_cancel_button = $('#is_cancel_button').val();
    let cancel_button_text = $('#cancel_button_text').val();
    let cancel_button_margin = $('#cancel_button_margin').val();
    let cancel_button_padding = $('#cancel_button_padding').val();
    let cancel_button_background_color = $('#cancel_button_background_color').val();
    let cancel_button_text_size = $('#cancel_button_text_size').val();
    let cancel_button_text_color = $('#cancel_button_text_color').val();
    let cancel_button_font_family = $('#cancel_button_font_family').val();
    let cancel_button_font_weight = $('#cancel_button_font_weight').val();
    let cancel_button_font_text_style = $('#cancel_button_font_text_style').val();
    let cancel_button_border = $('#cancel_button_border').val();
    let cancel_button_border_radius = $('#cancel_button_border_radius').val();
    let is_modal_close_mark = $('#is_modal_close_mark').val();
    let modal_close_mark_top = $('#modal_close_mark_top').val();
    let modal_close_mark_right = $('#modal_close_mark_right').val();
    let modal_close_mark_margin = $('#modal_close_mark_margin').val();
    let modal_close_mark_padding = $('#modal_close_mark_padding').val();
    let modal_close_mark_background_color = $('#modal_close_mark_background_color').val();
    let modal_close_mark_text_size = $('#modal_close_mark_text_size').val();
    let modal_close_mark_text_color = $('#modal_close_mark_text_color').val();
    let modal_close_mark_font_family = $('#modal_close_mark_font_family').val();
    let modal_close_mark_font_weight = $('#modal_close_mark_font_weight').val();

    let modal_display_position = $('#modal_display_position').val();
    let modal_top_offset = $('#modal_top_offset').val();
    let modal_bottom_offset = $('#modal_bottom_offset').val();
    let modal_left_offset = $('#modal_left_offset').val();
    let modal_right_offset = $('#modal_right_offset').val();
    let is_background = $('#is_background').val();
    let background_color = $('#background_color').val();
    let background_opacity = $('#background_opacity').val();

    $.ajax({
      url: '/push_notification/update_modal_style',
      type: 'POST',
      data: {
        push_topic_id: $('#push_topic_id').val(),
        is_device: is_device,
        modal_transition_second: modal_transition_second,
        modal_whole_margin: modal_whole_margin,
        modal_whole_padding: modal_whole_padding,
        modal_whole_width: modal_whole_width,
        modal_whole_height: modal_whole_height,
        modal_whole_border: modal_whole_border,
        modal_whole_radius: modal_whole_radius,
        paragraph_text: paragraph_text,
        paragraph_text_color: paragraph_text_color,
        modal_whole_background_color: modal_whole_background_color,

        modal_container_margin: modal_container_margin,
        modal_container_padding: modal_container_padding,

        is_reverse_icon_position: is_reverse_icon_position,
        modal_icon_object_fit: modal_icon_object_fit,
        modal_icon_width: modal_icon_width,
        modal_icon_height: modal_icon_height,
        modal_icon_margin: modal_icon_margin,
        modal_icon_padding: modal_icon_padding,

        paragraph_text_size: paragraph_text_size,
        paragraph_font_family: paragraph_font_family,
        paragraph_font_weight: paragraph_font_weight,
        paragraph_margin: paragraph_margin,
        paragraph_padding: paragraph_padding,
        paragraph_line_height: paragraph_line_height,
        is_reverse_buttons_position: is_reverse_buttons_position,
        buttons_justify_content: buttons_justify_content,
        is_permission_button: is_permission_button,
        permission_button_text: permission_button_text,
        permission_button_margin: permission_button_margin,
        permission_button_padding: permission_button_padding,
        permission_button_background_color: permission_button_background_color,
        permission_button_text_size: permission_button_text_size,
        permission_button_text_color: permission_button_text_color,
        permission_button_font_family: permission_button_font_family,
        permission_button_font_weight: permission_button_font_weight,
        permission_button_text_style: permission_button_text_style,
        permission_button_border: permission_button_border,
        permission_button_border_radius: permission_button_border_radius,
        cancel_button_text: cancel_button_text,
        is_cancel_button: is_cancel_button,
        cancel_button_margin: cancel_button_margin,
        cancel_button_padding: cancel_button_padding,
        cancel_button_background_color: cancel_button_background_color,
        cancel_button_text_size: cancel_button_text_size,
        cancel_button_text_color: cancel_button_text_color,
        cancel_button_font_family: cancel_button_font_family,
        cancel_button_font_weight: cancel_button_font_weight,
        cancel_button_font_text_style: cancel_button_font_text_style,
        cancel_button_border: cancel_button_border,
        cancel_button_border_radius: cancel_button_border_radius,
        is_modal_close_mark: is_modal_close_mark,
        modal_close_mark_top: modal_close_mark_top,
        modal_close_mark_right: modal_close_mark_right,
        modal_close_mark_margin: modal_close_mark_margin,
        modal_close_mark_padding: modal_close_mark_padding,
        modal_close_mark_background_color: modal_close_mark_background_color,
        modal_close_mark_text_size: modal_close_mark_text_size,
        modal_close_mark_text_color: modal_close_mark_text_color,
        modal_close_mark_font_family: modal_close_mark_font_family,
        modal_close_mark_font_weight: modal_close_mark_font_weight,

        modal_display_position: modal_display_position,
        modal_top_offset: modal_top_offset,
        modal_bottom_offset: modal_bottom_offset,
        modal_left_offset: modal_left_offset,
        modal_right_offset: modal_right_offset,
        is_background: is_background,
        background_color: background_color,
        background_opacity: background_opacity,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        alert('モーダルデザインを登録しました。');
        location.reload();
      }
    });
  });

  // #################################################################
  // プッシュ通知の公開設定
  // #################################################################
  $('.push_show_valid_select_box').on('change', function (event) {
    let push_topic_id = $('.push_show_valid_select_box:checked').data('push_topic_id');
    let is_device = $('.push_show_valid_select_box:checked').data('device');
    let show_valid = $('.push_show_valid_select_box:checked').val();

    $.ajax({
      url: '/push_notification/save_push_show_valid',
      type: 'POST',
      data: {
        // push_topic_id: push_topic_id,
        // push_ab_test_id: push_ab_test_id,
        push_topic_id: push_topic_id,
        is_device: is_device,
        show_valid: show_valid,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });


  // #################################################################
  // プッシュ通知モーダルの表示位置設定
  // #################################################################
  $('.push_modal_display_position_btn').on('click', function () {
    let push_topic_id = $('#push_topic_id').val();
    let modal_display_position = $(this).data('cdp');
    let is_device = $('.push_device_selects:checked').data('device');

    $.ajax({
      url: '/push_notification/save_push_modal_display_position',
      type: 'POST',
      data: {
        push_topic_id: push_topic_id,
        modal_display_position: modal_display_position,
        is_device: is_device,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // プッシュ通知モーダルの表示位置調整設定
  // #################################################################
  $('#modal_top_offset, #modal_bottom_offset, #modal_left_offset, #modal_right_offset').on('keypress blur', function (event) {
    // エンターキーが押されたかどうかをチェックし、エンターキーが押された場合にのみ処理を進めます
    if (event.type === 'keypress' && event.which !== 13) {
      return;
    }
    let push_topic_id = $('#push_topic_id').val();
    let push_position = $(this).data('position');
    let push_offset = $(this).val();
    let is_device = $('.push_device_selects:checked').data('device');

    if (!push_offset) {
      alert('入力して下さい。');
      return;
    }
    $.ajax({
      url: '/push_notification/save_push_modal_offset',
      type: 'POST',
      data: {
        push_topic_id: push_topic_id,
        push_position: push_position,
        push_offset: push_offset,
        is_device: is_device
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // プッシュ通知モーダルの背景の有無
  // #################################################################
  $('.push_background_select_box').on('change', function () {
    let push_topic_id = $('#push_topic_id').val();
    let is_background = $('.push_background_select_box option:selected').val();
    let is_device = $('.push_device_selects:checked').data('device');
    $.ajax({
      url: '/push_notification/save_push_is_background',
      type: 'POST',
      data: {
        push_topic_id: push_topic_id,
        is_background: is_background,
        is_device : is_device
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // プッシュ通知モーダルの背景色設定
  // #################################################################
  $('#push_background_color').on('change', function (event) {
    let push_topic_id = $('#push_topic_id').val();
    let background_color = $('#push_background_color').val();
    $.ajax({
      url: '/push_notification/save_push_background_color',
      type: 'POST',
      data: {
        push_topic_id: push_topic_id,
        background_color: background_color,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // プッシュ通知モーダルの背景の透過設定
  // #################################################################
  $('.push_background_opacity_select_box').on('change', function (event) {
    let push_topic_id = $('#push_topic_id').val();
    let background_opacity = $('.push_background_opacity_select_box option:selected').val();
    let is_device = $('.push_device_selects:checked').data('device');
    $.ajax({
      url: '/push_notification/save_push_background_opacity',
      type: 'POST',
      data: {
        push_topic_id: push_topic_id,
        background_opacity: background_opacity,
        is_device: is_device
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == '0') {
        location.reload();
      }
    });
  });

  // #################################################################
  // アイコン登録 プッシュモーダル or プッシュ通知本体
  // #################################################################
  $('#push_icon_upload_btn').on('click', function () {
    let element_id_name = $(this).attr('id');
    let push_topic_id = $(this).data('push_topic_id');
    let file_data = $('#push-icon').prop('files')[0];
    if (!file_data) {
      alert('画像を選択してください。');
      return;
    }
    let form_data = new FormData();
    form_data.append('icon_file', file_data);
    form_data.append('push_topic_id', push_topic_id);

    $.ajax({
      url: '/push_notification/upload_push_icon',
      type: 'POST',
      data: form_data,
      processData: false,
      contentType: false,
    })
      .done(function (data) {
        if (data.ret == 0) {
          location.reload();
        }else{
          alert(data.message);
        }
      })
      .fail(function () {
        alert('アイコンの登録に失敗しました。');
      });
  });


  // #################################################################
  /**
   * プッシュ通知のページを別ページで開くかどうかの設定トグルイベント
   * /push_notification/toggle_auth_type にPOST
   */
  $('#toggle-push-auth-type').change(function () {
    $.ajax({
      url: '/push_notification/toggle_auth_type',
      type: 'POST',
      data: {
        push_topic_id: $(this).data('push-topic-id'),
        is_other_page: $(this).prop('checked') ? 1 : 0,
      },
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      }else{
        alert('更新に失敗しました。');
      }
    });
  });



  /**
   * 許可ページの設定保存
   * /push_notification/save_auth_settings にPOST
   * shop_nameは100文字まで。optional.
   */
  $('#save-auth-settings').click(function () {
    let shop_name = $('#auth-shop-name').val();
    let push_topic_id = $(this).data('push-topic-id');

    if (shop_name.length > 100) {
      alert('ショップ名は100文字以内で入力してください。');
      return;
    }
    let formData = new FormData();
    formData.append('push_topic_id', push_topic_id);
    formData.append('shop_name', shop_name);

    $.ajax({
      url: '/push_notification/save_auth_settings',
      type: 'POST',
      data: formData,
      contentType: false, // コンテントタイプの設定をfalseに
      processData: false, // データをクエリ文字列に変換する処理を無効化
      dataType: 'json',
    }).done(function (data) {
      if (data.ret == 0) {
        location.reload();
      } else {
        alert(data.message);
      }
    }).fail(function () {
      alert('設定の保存に失敗しました。');
    });
  });


  /**
   * 画像アップロードイベント
   * プレビューをクリックすると、子要素のinput[type="file"]をクリックする
   * stopPropagationでバブリング防止。
   */
  $('.image-preview-wrapper').on('click', function (e) {
    if ($(e.target).is('input[type="file"]')) {
      e.stopPropagation();
    } else {
      $(this).children('input[type="file"]').click();
    }
  });

  /**
   * 画像アップロード検知イベント
   */
  $('.image-preview-wrapper input[type="file"]').off().on('change', function () {
    let wrapper = $(this).parent();
    let preview = $(this).parent().children('img');
    compressAndResizeImage(this.files[0], 128, 1024 * 1024, function(compressedBlob, error) {
      if (error) {
        alert('画像の容量が大きすぎます。');
        return;
      }
      const reader = new FileReader();
      reader.onload = function(e) {
        preview.attr('src', e.target.result);
      };
      reader.readAsDataURL(compressedBlob);
      wrapper.addClass('has-data');
      wrapper.removeClass('no-data');
    });
  });





  /**
   * #################################################################
   * アイコン画像のアップロード処理
   * 指定した
   * @param {File} file
   * @param {number} targetSize 画像の正方形のpxサイズ
   * @param {number} targetFileSize 画像のファイルサイズの上限
   * @param {function} callback
   * @return {void}
   */
    function compressAndResizeImage(file, targetSize, targetFileSize, callback) {
      const reader = new FileReader();
      reader.onload = function(e) {
        const img = new Image();
        img.onload = function() {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // 画像を128px四方の正方形にリサイズ
          const size = targetSize; // 正方形のサイズ
          canvas.width = size;
          canvas.height = size;

          // アスペクト比を保持しつつ中央でクロップするための計算
          let sourceX = 0;
          let sourceY = 0;
          let sourceWidth = img.width;
          let sourceHeight = img.height;
          const sourceAspect = img.width / img.height;
          const targetAspect = size / size;

          if (sourceAspect > targetAspect) {
            // 横長の画像の場合、横をトリミング
            sourceWidth = sourceHeight * targetAspect;
            sourceX = (img.width - sourceWidth) / 2;
          } else if (sourceAspect < targetAspect) {
            // 縦長の画像の場合、縦をトリミング
            sourceHeight = sourceWidth / targetAspect;
            sourceY = (img.height - sourceHeight) / 2;
          }

          ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, size, size);

          // 初期品質を設定（圧縮しない）
          let quality = 1.0;

          const compress = function(quality) {
            canvas.toBlob(function(blob) {
              if (blob.size <= targetFileSize || quality <= 0.1) {
                if (blob.size > targetFileSize) {
                  callback(null, 'サイズオーバー');
                } else {
                  callback(blob);
                }
              } else {
                // 目標のファイルサイズに達していない場合は、品質を下げて再帰的に圧縮を試みる
                compress(quality - 0.1);
              }
            }, 'image/png', quality);
          };

          compress(quality);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }




  /**
   * #################################################################
   * プッシュ通知投稿の作成画面
   * #################################################################
   */
  if ( $('#new-push-post-wrapper').length > 0 ) {
    // modal
    const loadingModal = document.querySelector("#loading-modal");

    $('#select-push-topic').on('change', function () {
      const topicId = $(this).val();
      if (topicId === "all") {
        location.href = '/push_notification/post';
      }else{
        location.href = `/push_notification/post?push_topic_id=${topicId}`;
      }
    });

    /**
     * #################################################################
     * 文字列制限の自動チェック
     * data-limit属性を持つinput要素が更新された時、対象要素のdata-nameと同じ値のdata-limit-nameを持つ要素の、テキストに文字数を表示する
     * また、文字数が制限を超えた時は、文字数を赤色にする( text-red-500クラスを付与 ）
     * @param {HTMLElement} callerElement
     * @return {void}
     */
    function checkLimit(callerElement){
      let limit = $(callerElement).data('limit');
      let name = $(callerElement).data('name');
      let countUpElement = $(`[data-limit-name="${name}"]`);
      let length = $(callerElement).val().length;
      countUpElement.text(`${length}`);
      // limitを超えた場合は赤色にする
      if (length > limit) {
        countUpElement.addClass('text-red-500');
      } else {
        countUpElement.removeClass('text-red-500');
      }
    }
    // 初期化とイベント設定
    $('[data-limit]').each(function () {
      checkLimit(this);
    })
      .on('input', function () {
        checkLimit(this);
      });

    /**
     * #################################################################
     * 投稿タイミングの切り替え時に、inputのdisabledを切り替える
     * @param {HTMLElement} caller
     * @return {void}
     */
    function changeScheduleDateEditable( caller ) {
      let isSchedule = $(caller).val() === 'schedule';
      $('#push-post-schedule-date').prop('disabled', !isSchedule);
      $('#push-post-schedule-time').prop('disabled', !isSchedule);
    }
    $('#push-post-timing').each(function () {
      changeScheduleDateEditable( this );
    })
      .on('change', function () {
        changeScheduleDateEditable( this );
      });

    /**
     * 時間の入力規制。分は30分単位で入力できるようにする。
     * 他の分を入力すると、自動で30分単位に変換する
     */
    $('#push-post-schedule-time').on('input', function () {
      let time = $(this).val();
      let hour = time.split(':')[0];
      let minute = time.split(':')[1];
      if (minute >= 30) {
        minute = '30';
      } else {
        minute = '00';
      }
      $(this).val(`${hour}:${minute}`);
    });



    /**
     * #################################################################
     * プッシュ通知投稿の作成
     * 必須項目
     * - タイトル ( title ) 文字数制限あり
     * - 本文 ( message ) 文字数制限あり
     * - 投稿タイミング ( isSchedule )
     *  - trueの場合は、投稿日時 ( schedule_date )
     * - リンク先URL ( jump_to_url )
     */
    $('#create-push-post').on('click', function () {
      const title = $('#push-post-title').val();
      const message = $('#push-post-message').val();
      const isSchedule = $("#push-post-timing").val() === 'schedule';
      const scheduleDate = $('#push-post-schedule-date').val();
      const scheduleTime = $('#push-post-schedule-time').val();
      const scheduleDateTime = `${scheduleDate}T${scheduleTime}`;
      const jumpToUrl = $('#push-post-link').val();

      // 必須項目のチェック
      if ( title.trim() === "" ) {
        alert('タイトルは必須です。');
        return;
      }
      if ( message.trim() === "" ) {
        alert('本文は必須です。');
        return;
      }
      if ( jumpToUrl.trim() === "" ) {
        alert('リンク先URLは必須です。');
        return;
      }
      if ( isSchedule && ( scheduleDate.trim() === "" || scheduleTime.trim() === "" )){
        alert('予約投稿の場合は、投稿日時の指定が必須です。');
        return;
      }

      // 文字数チェック
      if ( title.length > 40 ) {
        alert('タイトルは40文字以内で入力してください。');
        return;
      }
      if ( message.length > 200 ) {
        alert('本文は200文字以内で入力してください。');
        return;
      }
      if ( jumpToUrl.length > 255 ) {
        alert('リンク先URLは255文字以内で入力してください。');
        return;
      }

      // 予約投稿が現在時刻から1時間以内の場合は拒否
      if ( isSchedule ) {
        const now = new Date();
        const schedule = new Date(scheduleDateTime);
        if ( schedule < now ) {
          alert('過去の日時は指定できません。');
          return;
        }
        if ( schedule - now < 1000 * 60 * 60 ) {
          alert('1時間以内の日時は指定できません。');
          return;
        }
      }
      setTimeout(function() { loadingModal.showModal(); }, 0);

      $.ajax({
        url: '/push_notification/create_push_post',
        type: 'POST',
        data: {
          push_post_id: $('#push-post-id').val(),
          push_topic_id: $('#push-topic-id').val(),
          title: title,
          message: message,
          is_schedule: isSchedule,
          schedule_datetime: scheduleDateTime,
          jump_to_url: jumpToUrl,
        },
        dataType: 'json',
      })
        .done(function (data) {
          if (data.ret === 0) {
            // 予約か即時投稿かでメッセージを変える
            if ( isSchedule ) {
              alert('プッシュ通知を予約しました。');
            } else {
              alert('プッシュ通知を送信しました。');
            }
            location.href = '/push_notification/post_history';
          }
        })
        .fail(function () {
          alert('プッシュ通知投稿の作成に失敗しました。');
        })
        .always(function() {
          loadingModal.close();
        });
    });

    /**
     * #################################################################
     * プッシュ通知投稿の削除、キャンセル
     */
    $('#delete-push-post').on('click', function () {
      if ( !confirm('この投稿をキャンセルしますか？\n※キャンセル後は元に戻せません') ) {
        return;
      }

      setTimeout(function() { loadingModal.showModal(); }, 0);
      $.ajax({
        url: '/push_notification/delete_push_post',
        type: 'POST',
        data: {
          push_post_id: $('#push-post-id').val(),
        },
        dataType: 'json',
      })
        .done(function (data) {
          if (data.ret === 0) {
            alert('この投稿をキャンセルしました');
            location.href = '/push_notification/post_history';
          }
        })
        .fail(function () {
          alert('キャンセルに失敗しました。');
        })
        .always(function() {
          loadingModal.close();
        });

    });

  } // end if ( $('#new-push-post-wrapper').length > 0 )


  // #################################################################
  // 投稿履歴ページの処理
  if ( $('#push-post-history-wrapper').length ) {
    /**
     * #################################################################
     * 履歴を表示するトピックの変更
     *  すべてなら指定なし、それ以外ならtopic_idを指定してリダイレクト
     */
    $('#select-push-topic').on('change', function () {
      const topicId = $(this).val();
      if (topicId === "all") {
        location.href = '/push_notification/post_history';
      }else{
        location.href = `/push_notification/post_history?push_topic_id=${topicId}`;
      }
    });

  } // end if ( $('#push-post-history-wrapper').length )


});
